import Vue from "vue";

import elementDecor from "./element-decor/element-decor";
import serviceCollapse from "./service-collapse/service-collapse";
import uiInput from "@/components/ui/ui-input/ui-input";

Vue.component("element-decor", elementDecor);
Vue.component("ui-input", uiInput);
Vue.component("service-collapse", serviceCollapse);
